var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiBtnIconSd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.675 1.92c.122-.416.712-.416.834 0l.815 2.773a.58.58 0 00.393.393l2.772.815c.417.122.417.712 0 .835l-2.772.814a.58.58 0 00-.393.393l-.815 2.773c-.122.416-.712.416-.834 0L7.86 7.943a.58.58 0 00-.393-.393l-2.772-.814c-.417-.123-.417-.713 0-.835l2.772-.815a.58.58 0 00.393-.393l.815-2.772z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M3.722 8.45c.082-.278.476-.278.558 0l.466 1.586c.05.171.184.305.355.355l1.586.466c.279.082.279.477 0 .559l-1.586.465a.524.524 0 00-.355.355l-.466 1.587c-.082.278-.476.278-.558 0l-.466-1.587a.524.524 0 00-.355-.355l-1.586-.466c-.279-.081-.279-.476 0-.558l1.586-.466a.524.524 0 00.355-.355l.466-1.586z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/AIBtnIcon_sd.c8397c9d.svg";
export { SvgAiBtnIconSd as ReactComponent };